import { Component, PropTypes } from 'react';
import $ from 'jquery';
import stylesHeader from 'styles/chrome';
import stylesWeather from 'styles/weather';

export default class Weather extends Component {
	static propTypes = {
		forecast: PropTypes.string.isRequired,
		useCelsius: PropTypes.bool
	}

	componentDidMount() {
		const dataUrl = __DEV__ ? 'scripts/mocks/weather.json' : `/weather/getForecast/json/false/false/${this.props.forecast}`;
		$.getJSON(dataUrl, ([{ location: { international: isCelsius }, currentConditions }]) => this.setWeather(currentConditions, isCelsius));
	}

	setWeather({ temperature: temperatureCelsius, icon }, isCelsius) {
		let temperatureFahrenheit;

		if (this.props.useCelsius !== isCelsius) {
			temperatureFahrenheit = this.convertToFahrenheit(temperatureCelsius);
		}

		$(this.refs.temperature).html(`${temperatureFahrenheit || temperatureCelsius}&deg;`);
		$(this.refs.icon).addClass(stylesWeather[`iconWeather${Math.abs(icon)}`]);
	}

	convertToFahrenheit(temperature) {
		return Math.round(((temperature * 9) / 5) + 32);
	}

	render() {
		return (
			<div className={stylesHeader.panel}>
				<span className={stylesHeader.copyAside}>Weather in Rio</span>
				<span className={stylesHeader.copyMain} ref="temperature" />
				<span className={stylesWeather.iconWeather} ref="icon" />
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./scripts/components/Weather.es6
 **/